import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://12345backbot6789.aminwarind.cloud/api';

const DEBUG_API =
  typeof window !== 'undefined' && window.localStorage?.getItem('DEBUG_API') === '1';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor
api.interceptors.request.use(
  (config) => {
    if (DEBUG_API) {
      console.log(`[DEBUG_API] ${config.method?.toUpperCase()} ${config.baseURL}${config.url}`);
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    console.error('API Error:', error.response?.data || error.message);
    return Promise.reject(error);
  }
);

// Bot Management API
export const botAPI = {
  start: (bidLimit) => api.post('/bot/start', { bid_limit: bidLimit }),
  stop: () => api.post('/bot/stop'),
  getStatus: () => api.get('/bot/status'),
  getStatistics: () => api.get('/bot/statistics'),
};

// Projects API
export const projectsAPI = {
  getAll: (limit = 100) => api.get(`/projects?limit=${limit}`),
  getById: (projectId) => api.get(`/projects/${projectId}`),
};

// Bids API
export const bidsAPI = {
  getAll: (limit = 50) => api.get(`/bids?limit=${limit}`),
  getById: (bidId) => api.get(`/bids/${bidId}`),
};

// Configuration API
export const configAPI = {
  get: () => api.get('/config'),
  update: (config) => api.put('/config', config),
};

// Logs API
export const logsAPI = {
  getAll: (sessionId, limit = 200) => {
    const params = new URLSearchParams();
    params.set('limit', String(limit));
    if (sessionId && sessionId !== 'null' && sessionId !== 'undefined') {
      params.set('session_id', sessionId);
    }
    return api.get(`/logs?${params.toString()}`);
  },
  getSummary: (sessionId) => {
    const params = new URLSearchParams();
    if (sessionId && sessionId !== 'null' && sessionId !== 'undefined') {
      params.set('session_id', sessionId);
    }
    const q = params.toString();
    return api.get(q ? `/logs/summary?${q}` : '/logs/summary');
  },
};

// Analytics API
export const analyticsAPI = {
  getOverview: () => api.get('/analytics/overview'),
  getPerformance: () => api.get('/analytics/performance'),
};

// Health check
export const healthAPI = {
  check: () => api.get('/health'),
};

// Server diagnostics (no secrets)
export const diagnosticsAPI = {
  summary: () => api.get('/diagnostics'),
  testFreelancer: (sessionId) => api.post(`/sessions/${sessionId}/diagnostics/test-freelancer`),
  testGroq: (sessionId) => api.post(`/sessions/${sessionId}/diagnostics/test-groq`),
};

// Auth API
export const authAPI = {
  login: (username, password, takeover = false) =>
    api.post('/login', { username, password, takeover }),
  logout: () => api.post('/logout'),
};

export default api;


